// 定义API响应类型 — 匹配 unifiedApi 的 ApiResponse
interface ApiResponse<T = any> {
  success: boolean;
  code: number;
  data: T;
  message?: string;
}

// Utility function to handle common response format
const handleApiResponse = async <T>(apiCall: Promise<ApiResponse<T>
>): Promise<{ data: T; total: number; success: boolean; message?: string }> => {
  try {
    const response = await apiCall;
    const apiResponse = response.data as any;

    // 检查API是否返回成功
    if (!response.success) {
      throw new Error(response.message || 'API调用返回失败状态');
    }

    // 返回成功的数据
    // 支持两种格式：
    // 1. { data: { data: T, count: number } } - 嵌套格式
    // 2. { data: T } - 扁平格式
    const extractedData = apiResponse?.data ?? apiResponse;
    const extractedTotal = apiResponse?.count || 0;

    return {
      data: extractedData,
      total: extractedTotal,
      success: true
    };
  } catch (error: any) {
    // 捕获所有错误，包括网络错误和API返回的错误状态
    console.error('API请求失败:', error);

    // 构造统一的错误响应格式
    const errorResponse = {
      success: false,
      code: error?.response?.status || 500,
      data: null as unknown as T,
      total: 0,
      message: error?.message || 'API 调用失败'
    };

    // 抛出一个包含完整错误信息的错误对象，而不只是一个简单的错误消息
    throw errorResponse;
  }
};

export default handleApiResponse;
